package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/**
 * DSL 内建对象 `debug` 暴露的反应式内省/调试方法（仅作为类型标记）。
 * INSTANCE 单例由消费方（ExprEvaluator/DebugApiInvoker）通过 INSTANCE 引用。
 */
class DebugApi private constructor() {
    companion object {
        @JvmField
        val INSTANCE: DebugApi = DebugApi()

        /** 与 INSTANCE 等价（本类无状态）。 */
        @JvmField
        val NOOP: DebugApi = INSTANCE
    }
}
